import { request } from "../../../config/helpers/axios-instance";

const updateFutureOrder = async (order, id) =>

    await request({
        url: `userOrder/admin/id/` + id,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        data: order

    })
export { updateFutureOrder };